const IMAGE_CDN = "https://cdn.media.amplience.net/i/SweatyBetty";

export function resolveImageUrl(link: string): string {
  if (link.startsWith("http")) return link;
  return `${IMAGE_CDN}${link}`;
}
